// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M12 3L15.2292 8.52274L21.5 9.87539L17.225 14.6413L17.8713 21L12 18.4227L6.12868 21L6.775 14.6413L2.5 9.87539L8.77077 8.52274L12 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"star-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 3L15.2292 8.52274L21.5 9.87539L17.225 14.6413L17.8713 21L12 18.4227L6.12868 21L6.775 14.6413L2.5 9.87539L8.77077 8.52274L12 3Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3L15.2292 8.52274L21.5 9.87539L17.225 14.6413L17.8713 21L12 18.4227L6.12868 21L6.775 14.6413L2.5 9.87539L8.77077 8.52274L12 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Star1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'star-1',
    ref,
    icon: element,
  },
));

Star1Icon.displayName = 'Star1Icon';

export default Star1Icon;
